import React from 'react';
import './PhotoModal.css';

const PhotoModal = ({ photoUrl, photoTitle, open, onClose }) => {
  if (!open) return null;

  return (
    <div className="photo-modal-overlay" onClick={onClose}>
      <div className="photo-modal-content" onClick={e => e.stopPropagation()}>
        <button className="photo-modal-close" onClick={onClose}>&times;</button>
        <img 
          src={photoUrl} 
          alt={photoTitle || 'Photo'} 
          className="photo-modal-image"
          loading="eager"
          decoding="async"
        />
        {photoTitle && (
          <div className="photo-modal-title">{photoTitle}</div>
        )}
      </div>
    </div>
  );
};

export default React.memo(PhotoModal);